<div class="session">
  <div class="session-content text-xs-center">
    <div>
      <div class="error-title">Wrong App</div>
      <div class="error-subtitle">You have a Savvy Pet account.</div>
      <div class="error-subtitle">Please login to Savvy Pet instead.</div>
      <br>
      <a [href]="savvyPetUrl" mat-flat-button color="accent">Go to Savvy Pet</a>
    </div>
  </div>
</div>
